import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Heading, Container, Paragraph } from '@scentregroup/ui'
import { matchMedia, breakpointTabletQuery } from '../../helpers/match-media'
import StarRating from '../star-rating'
import analyticsUtils from '../../helpers/analytics-utils'
import { lazyloadWrapper } from '../../helpers/lazyload-wrapper'
import { EvolvedContextConsumer } from '../../context'
import { reviewsType } from './types'
import ReviewList from './review-list'

import style from './index.module.scss'

class Reviews extends Component {
  constructor(props) {
    super(props)

    this.tabletMatchMedia = matchMedia(breakpointTabletQuery)
    const isTabletOrSmaller = this.tabletMatchMedia.matches
    this.state = {
      isTabletOrSmaller,
    }
  }

  componentDidMount() {
    this.trackModuleImpression()
    this.tabletMatchMedia.addListener(this.gridSizeChanged)
  }

  componentWillUnmount() {
    this.tabletMatchMedia.removeListener(this.gridSizeChanged)
  }

  gridSizeChanged = event => {
    this.setState({ isTabletOrSmaller: event.matches })
  }
  trackModuleImpression = () => {
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.MODULE_IMPRESSION,
      eventCategory: analyticsUtils.categories.USER_GENERATED_CONTENT,
      eventAction: analyticsUtils.actions.REVIEWS_MODULE_SHOW,
    })
  }

  trackModuleClick = () => {
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.USER_CLICK,
      eventCategory: analyticsUtils.categories.USER_GENERATED_CONTENT,
      eventAction: analyticsUtils.actions.REVIEWS_SEE_MORE,
    })
  }
  render() {
    const { title, rating, count, entries, color, centreTitle } = this.props
    const { isTabletOrSmaller } = this.state

    if (!rating || !count) {
      return null
    }

    const basedText = isTabletOrSmaller ? 'Based on' : null
    const starRating = (
      <Paragraph className={style.starRating}>
        <StarRating starRating={Math.floor(rating)} starTotal={5} />
      </Paragraph>
    )

    return (
      <EvolvedContextConsumer>
        {isEvolved => (
          <Container
            centred
            type="large"
            className={classNames(style.container)}
          >
            <Heading
              data-test-id="reviews-heading"
              type="large"
              className={style.heading}
            >
              {title}
            </Heading>

            <div className={style.reviews}>
              <div className={style.summary}>
                <Paragraph className={style.averageWrapper}>
                  <span className={style.score}>{rating}</span>
                  {' average '}
                </Paragraph>

                {isTabletOrSmaller && starRating}

                <div className={style.summaryDetails}>
                  <Paragraph className={style.basedText}>
                    {basedText} {count} reviews &amp; ratings
                  </Paragraph>

                  {!isTabletOrSmaller && starRating}
                </div>
              </div>

              <div
                data-test-id="review-list-wrapper"
                className={style.reviewListWrapper}
              >
                <ReviewList
                  centreTitle={centreTitle}
                  reviews={entries}
                  color={isEvolved ? null : color}
                />
              </div>
            </div>
          </Container>
        )}
      </EvolvedContextConsumer>
    )
  }
}

Reviews.propTypes = {
  title: PropTypes.string,
  rating: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  entries: reviewsType.isRequired,
  color: PropTypes.string,
  centreTitle: PropTypes.string,
}
export const RawReviews = Reviews
export default lazyloadWrapper(RawReviews)
